// shadcn-совместимый хелпер для склейки классов с корректной обработкой tailwind-конфликтов.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
